import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Soft-deletes a role and removes its junction associations.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the role to delete.
 * @returns OperationResult (no payload).
 */
export const deleteRole = async (instance: KyInstance, uid: string) => {
  try {
    return await instance.delete<OperationResult>(formatString(Uri.roles.byUid, uid)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
